// Auto generated file, do not manually modify!
// com.hotpads.capps.client.enums.termsandconditions.TermSetStatus

export enum TermSetStatus {
  CURRENT = 'CURRENT',
  NEVER = 'NEVER',
  PREVIOUS = 'PREVIOUS',
}

export const TermSetStatus_values = [TermSetStatus.CURRENT, TermSetStatus.NEVER, TermSetStatus.PREVIOUS] as const;
